import React from 'react';
import {useSuspenseQuery} from '@tanstack/react-query';
import {getQueryKey} from '@shared/queryKeyMap';
import {diApi} from '@di-shared/api/di';
import {callScheme} from '@di-shared/utils/appSchemeUtil';
import {t} from '@di-shared/features/common/useInferableTranslation';

interface MyMaintenanceGradeWarningLightProps {
  vin: string;
}

function MyMaintenanceGradeWarningLight({vin}: MyMaintenanceGradeWarningLightProps) {
  const {data} = useSuspenseQuery({
    queryKey: [getQueryKey(diApi.cpo.getDtcList1), vin],
    queryFn: () => diApi.cpo.getDtcList1({vin}),
  });
  const isWarningLightDetected = data.data.breakDownList.length > 0;

  if (!isWarningLightDetected) {
    return null;
  }
  return (
    <div className="warning_light">
      <a
        role="button"
        className="warning_light_link"
        onClick={() => callScheme('app://sdkcarinspection')}
      >
        <span className="ic ic_filled_caution_16px"></span>
        <span className="warning_light_text">{t('T30383')}</span>
        <span
          className="ic ic_arrow_forward_16px"
          aria-hidden="true"
        ></span>
      </a>
    </div>
  );
}

export default MyMaintenanceGradeWarningLight;
